import { defineAsyncComponent } from 'vue'

export const DebugDialog = defineAsyncComponent(() => import('../DebugDialog.vue'))
